import { takeEvery, put, call } from 'redux-saga/effects';
import * as actions from '../actions/chargeAnalysis';
import * as API from '../api/chargeAnalysis';
import { sessionErrorHandling } from './session';

function* download(action) {
    try {
        const { payload, callback, showSignificantVariance, showLowConfidenceClaims } = action.payload;
        yield put({ type: actions.CHARGE_ANALYSIS_DOWNLOAD_REPORT_PENDING });
        const response = yield call(API.downloadReport, payload, showSignificantVariance, showLowConfidenceClaims);
        yield put({ type: actions.CHARGE_ANALYSIS_DOWNLOAD_REPORT_FULFILLED });

        if (callback) {
            callback(response);
        }
    }
    catch (error) {
        const { error: errorMessage } = (error && error.payload) || { error: '' };
        yield put({ type: actions.CHARGE_ANALYSIS_DOWNLOAD_REPORT_REJECTED, payload: errorMessage });
        yield call(sessionErrorHandling, error);
    }
}

export default function* () {
    yield takeEvery(actions.CHARGE_ANALYSIS_DOWNLOAD_REPORT, download);
    
}